import { IGlobalState } from '../../../Root/store/appReducer'

export const getDomains = (state: IGlobalState) => state.domainAdmin?.domains
export const getDomainsLoading = (state: IGlobalState) => state.domainAdmin?.loading
export const getDomainsAdding = (state: IGlobalState) => state.domainAdmin?.adding
export const getDomainsRemoving = (state: IGlobalState) => state.domainAdmin?.removing
export const getDomainsVerifying = (state: IGlobalState) => state.domainAdmin?.verifying
export const getAddedDomain = (state: IGlobalState) => state.domainAdmin?.addedDomain
export const getEmailSignupDomain = (state: IGlobalState) => state.domainAdmin?.emailSignupDomain
export const getGoogleSignupDomain = (state: IGlobalState) => state.domainAdmin?.googleSignupDomain
export const getSettingsLoading = (state: IGlobalState) => state.domainAdmin?.settingsLoading
export const getSettingsUpdating = (state: IGlobalState) => state.domainAdmin?.settingsUpdating
